import { PriorityFilterStatus } from "@/enum/list.enum";

import { List } from "../schema/list";

/**
 * Build a ReadyToSend (Review-to-send) deep-link scoped to a whole list — used by the bulk "Review &
 * edit campaign" reach-out action, which pre-assigns the selected leads to a campaign (no send) and
 * then drops the user into Review to check them. Unlike {@link resolveLeadReviewTarget} there is no
 * single prospect to search for, so only the list filter is pinned; `assignStatus=["ALL"]` keeps the
 * just-assigned DRAFT/pre-assigned leads visible and `priorityFilterStatus=[ALL]` avoids dropping a
 * disqualified lead.
 *
 * Pass the `reviewSessionId` returned by `bulkAssign` to scope the view to exactly the assigned
 * leads (PREC-3648) — without it, Review pages through the whole list.
 */
export const buildReadyToSendListLink = (
	list: Pick<List, "id" | "name"> | undefined,
	reviewSessionId?: number
): string => {
	const listIds = list
		? `&listIds=${encodeURIComponent(
				JSON.stringify([{ title: list.name, id: list.id, checked: true }])
			)}`
		: "";

	const reviewSession =
		reviewSessionId !== undefined ? `&reviewSessionId=${encodeURIComponent(reviewSessionId)}` : "";

	return (
		`/app/messages/ready-to-send?priorityFilterStatus=${encodeURIComponent(
			JSON.stringify([PriorityFilterStatus.ALL])
		)}` + `&assignStatus=${encodeURIComponent(JSON.stringify(["ALL"]))}${listIds}${reviewSession}`
	);
};
